<template>
  <main>
    <div class="wrapper">
      <div class="video_wrapper" :key="video.id">
        <iframe
          ref="aFrame"
          class="video"
          :src="homelink"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
          mozallowfullscreen
          webkitallowfullscreen
        >Working</iframe>
      </div>
    </div>
  </main>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted, nextTick } from "vue";
import { useHead } from "@unhead/vue";
import { useMainStore } from "@/store";
import Video from "@/models/Videos";

export default defineComponent({
  name: "DisplayVideo",
  props: {
    home: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const store = useMainStore();
    const aFrame = ref<HTMLIFrameElement>();

    const video = computed(() => {
      return store.videos.find((video: Video) => video.id == props.id);
    });

    useHead(
      computed(() => ({
        title: `${video.value?.name} | Hugo Cohen `,
        meta: [
          {
            name: video.value?.name || "",
          },
        ],
      }))
    );

    const link = computed(() => {
      if (video.value?.host == "vimeo") {
        return "https://player.vimeo.com" + video.value.uri;
      }
      return "https://www.youtube.com/embed/" + video.value?.uri;
    });

    const homelink = computed(() => {
      if (props.home === true) {
        return link.value + "?autoplay=1&autopause=1&loop=1&muted=1";
      } else {
        return link.value + "?loop=1";
      }
    });

    onMounted(() => {
      if (props.home == false) {
        nextTick(() => {
          aFrame.value?.requestFullscreen();
        });
      }
    });

    return {
      aFrame,
      video,
      link,
      homelink,
    };
  },
});
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.video_wrapper {
  width: 100%;
  height: 100%;
  padding-bottom: 56.25%;
  padding-top: 30px;
  height: 0;
  overflow: hidden;
  & iframe {
    position: absolute;
    border: 0px;
    height: 80%;
    width: 100%;
    left: 0;
    top: 10vh;
  }
}

.title {
  padding: 10px;
}
</style>
